var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import typography from '../../Typography';
import WixComponent from '../../BaseComponents/WixComponent';

var TextLinkLayout = function (_WixComponent) {
  _inherits(TextLinkLayout, _WixComponent);

  function TextLinkLayout(props) {
    _classCallCheck(this, TextLinkLayout);

    var _this = _possibleConstructorReturn(this, (TextLinkLayout.__proto__ || Object.getPrototypeOf(TextLinkLayout)).call(this, props));

    _this.state = {
      isHover: false
    };

    _this.toggleHover = _this.toggleHover.bind(_this);
    return _this;
  }

  _createClass(TextLinkLayout, [{
    key: 'toggleHover',
    value: function toggleHover() {
      this.setState({
        isHover: !this.state.isHover
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isHover = this.state.isHover;
      var _props = this.props,
          darkBackground = _props.darkBackground,
          underlineStyle = _props.underlineStyle,
          size = _props.size,
          children = _props.children;


      var color = darkBackground ? isHover ? '#F0F4F7' : '#FFFFFF' : isHover ? '#4EB7F5' : '#3899EC';

      var style = {
        color: color,
        background: 'none',
        cursor: 'pointer',
        textDecoration: underlineStyle === 'hover' && isHover || underlineStyle === 'always' ? 'underline' : 'none'
      };

      var className = size === 'medium' ? typography.t1_3 : typography.t3_3;

      return React.createElement(
        'div',
        {
          role: 'link',
          className: className,
          style: style,
          onMouseLeave: this.toggleHover,
          onMouseEnter: this.toggleHover
        },
        children
      );
    }
  }]);

  return TextLinkLayout;
}(WixComponent);

TextLinkLayout.propTypes = {
  children: PropTypes.node,
  underlineStyle: PropTypes.oneOf(['always', 'hover', 'never']),
  darkBackground: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
};
TextLinkLayout.defaultProps = {
  underlineStyle: 'hover',
  darkBackground: false,
  size: 'medium'
};
export default TextLinkLayout;
//# sourceMappingURL=TextLinkLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/BaseComponents/TextLinkLayout/TextLinkLayout.js